define('settings/lib/country-selector/country-selector',['require','exports','module','durandal/app','knockout','jquery','plugins/dialog','lodash','massage-countries','lib/audio/audio-default-countries','api-access','api-access','dialog-helper/responsive','i18next'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var $ = require('jquery');
    var dialog = require('plugins/dialog');
    var _ = require('lodash');
    var massageCountries = require('massage-countries');
    var audioDefaultCountries = require('lib/audio/audio-default-countries');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var responsiveDialog = require('dialog-helper/responsive');
    var i18n = require('i18next');

    var defaultOptions = {
        onSave: function (selectedCountries, preferredCountry, tollFree) {
            var countrySettings;

            // prepare data based on phone number type
            if (!tollFree) {
                countrySettings = {
                    defaultTollCountries: selectedCountries,
                    preferredTollCountry: preferredCountry
                };
            } else {
                countrySettings = {
                    defaultTollFreeCountries: selectedCountries,
                    preferredTollFreeCountry: preferredCountry
                };
            }

            return userApi.updateSettings(countrySettings)
                .then(function () {
                    if (tollFree) {
                        window.mixpanel.track('Save Toll-Free Countries', {
                            'Default Countries': countrySettings.defaultTollFreeCountries,
                            'Preferred Country': countrySettings.preferredTollFreeCountry
                        });
                    } else {
                        window.mixpanel.track('Save Toll Countries', {
                            'Default Countries': countrySettings.defaultTollCountries,
                            'Preferred Country': countrySettings.preferredTollCountry
                        });
                    }
                });
        },

        loadAudioSettings: userApi.settings,

        loadUserInfo: userApi.me,

        titleKeyPrefix: 'alternateNumber.info.'
    };

    var CountrySelector = function (title, tollFree, optionsResponse) {
        var options = _.merge({}, defaultOptions, optionsResponse);

        var self = this;

        self.options = options;
        self.audioSettings = ko.observable();

        self.title = ko.observable(options.titleKeyPrefix + title);
        self.countries = ko.observableArray();
        self.selectedCountries = ko.observableArray().extend({
            required: {
                message: i18n.t('settings.overlay.required')
            }
        });
        self.allowedCountries = ko.observableArray();
        self.preferredCountry = ko.observable();
        self.saved = ko.observable(false);

        // boolean value of tollFree or not
        self.tollFree = ko.observable(tollFree);

        self.query = ko.observable('');

        self.computedCountries = ko.computed(function () {
            var sortedCountries = self.countries().sort(function (a, b) {
                return i18n.t('countries.' + a.code).localeCompare(i18n.t('countries.' + b.code));
            });

            return ko.utils.arrayFilter(sortedCountries, function (country) {
                // filter based on the search query using the translated country name
                return i18n.t('countries.' + country.code).toLowerCase().indexOf(self.query().toLowerCase()) >= 0;
            });
        });

        self.massageCountries = function (countries) {
            return massageCountries(countries);
        };

        self.noCountrySelected = ko.computed(function () {
            return (self.selectedCountries().length === 0);
        });

        self.preferredCountry.subscribe(function () {
            // detect if preferred country has been removed from selected countries
            if (self.selectedCountries().indexOf(self.preferredCountry()) === -1) {
                self.preferredCountry('');
            }
        });

        self.setPreferredCountry = function (country) {
            if (self.preferredCountry() === country.code) {
                return self.preferredCountry('');
            }

            self.preferredCountry(country.code);
            return undefined;
        };

        self.allSelected = ko.observable(false);

        self.selectAll = ko.computed({
            read: function () {
                return self.selectedCountries().length === self.allowedCountries().length;
            },
            write: function () {
                self.selectedCountries(self.selectedCountries().length === self.allowedCountries().length ?
                    [] : self.allowedCountries().slice(0));
            },
            owner: self
        });

        self.show = function () {
            return dialog.show(self);
        };

        self.compositionComplete = function (container, modalEl) {
            var availableHeight = window.innerHeight;
            var maxHeight = availableHeight * 0.8;

            if (modalEl.clientHeight < maxHeight) {
                return;
            }

            var header = modalEl.querySelector('.modal-header');
            var footer = modalEl.querySelector('.modal-footer');
            var body = modalEl.querySelector('.modal-body');
            var ul = body.querySelector('.countries');
            var searchBox = body.querySelector('.form-control');
            var height = function (el) { return el.offsetHeight };
            // we have 22 extra pixes between padding/margin and borders of the inner body elements
            // so we need to consider that when recalculating the  size of the ul list of counties
            var padding = 10 + 8 + 2 + 2;

            ul.style.height = (maxHeight - height(header) - height(footer) - height(searchBox) - padding) + 'px';
        };

        self.save = function () {
            return self.options.onSave(self.selectedCountries(), self.preferredCountry(), self.tollFree())
                .then(function () {
                    self.saved(true);
                    dialog.close(self, self.saved());

                    // update settings
                    app.trigger('get:country-settings');
                })
                .fail(function () {
                    self.saved(false);
                    dialog.close(self, self.saved());
                });
        };

        self.cancel = function () {
            dialog.close(self);
        };

        self.activate = function () {
            responsiveDialog('.country-selector', self);

            var getDefaultCountries = function (defaultCountries, allowedCountries) {
                var countriesPromise = $.Deferred();
                var billingCountry;

                commerceApi.getBilling()
                    .then(function (billing) {
                        billingCountry = billing.country;
                    })
                    .always(function () {
                        countriesPromise.resolve(
                            audioDefaultCountries(
                                defaultCountries,
                                allowedCountries,
                                billingCountry
                            )
                        );
                    });

                return countriesPromise;
            };

            return $.when(self.options.loadAudioSettings(), self.options.loadUserInfo())
                .then(function (userSettingsResponse) {
                    var data = userSettingsResponse[0];

                    if (!self.tollFree()) {
                        self.audioSettings(data.audio);
                        self.allowedCountries(data.audio.allowedTollCountries);
                        self.countries(massageCountries(data.audio.allowedTollCountries));

                        var defaultTollCountries = data.audio.defaultTollCountries;
                        var allowedTollCountries = data.audio.allowedTollCountries;

                        return getDefaultCountries(defaultTollCountries, allowedTollCountries)
                            .then(function (countries) {
                                self.selectedCountries(countries);

                                if (self.countries().length === self.selectedCountries().length) {
                                    self.allSelected(true);
                                }

                                self.preferredCountry(data.audio.preferredTollCountry);
                            });
                    } else if (self.tollFree()) {
                        self.audioSettings(data.audio);
                        self.allowedCountries(data.audio.allowedTollFreeCountries);
                        self.countries(massageCountries(data.audio.allowedTollFreeCountries));

                        var defaultTollFreeCountries = data.audio.defaultTollFreeCountries;
                        var allowedTollFreeCountries = data.audio.allowedTollFreeCountries;

                        return getDefaultCountries(defaultTollFreeCountries, allowedTollFreeCountries)
                            .then(function (countries) {
                                self.selectedCountries(countries);

                                if (self.countries().length === self.selectedCountries().length) {
                                    self.allSelected(true);
                                }

                                self.preferredCountry(data.audio.preferredTollFreeCountry);
                            });
                    }
                    return undefined;
                });
        };
    };

    module.exports = CountrySelector;
});

